import React from 'react';

const Photo = () => {
    return (
        <div>Photo</div>
    );
}

export default Photo;